import { Box, Button, Paper, TextField, Typography, Grid, Accordion, AccordionSummary, AccordionDetails, List, ListItem, ListItemText, Card } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import configSiteUrls from '../../../configs/configSiteUrls';

import { useGetCentroApoioByLoginMutation } from '../centroApoioApiSlice';
import { IScentroApoio, IScentroApoioList, CentroApoioList, CentroApoio } from '../types/CentroApoio';
import { Iso } from '@mui/icons-material';
import { CentroApoioAnexo } from '../types/CentroApoioAnexo';
import { useGetCentroApoioAnexosQuery, useGetCentroApoioAnexosRespostaQuery } from '../centroApoioAnexoApiSlice';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import GeralAnexosUpload from '../../licitacao/create/GeralAnexosUpload';
import DownloadAnexoButton from '../../noticia/create/DownloadAnexoButton';
import { format } from 'date-fns';
import { CentroApoioPainelDadoAtual } from './CentroApoioPainelDadoAtual';
import { CentroApoioPainelAlteraDado } from './CentroApoioPainelAlteraDado';

export const CentroApoioConsultaView = () => {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [edicao, setEdicao] = useState(false);

  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [dados, setDados] = useState<CentroApoioList>(IScentroApoioList);

  const [consultarCentroApoio, status] = useGetCentroApoioByLoginMutation();

  const [centroApoioAnexoSalvo, setCentroApoioAnexoSalvo] = useState<CentroApoioAnexo[] | null>(null);
  const { data: dataAnexo, isLoading: isLoadingAnexo } = useGetCentroApoioAnexosQuery({ idCentroApoioAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexo) {
      setCentroApoioAnexoSalvo(dataAnexo);
    }
  }, [dataAnexo]);

  const [centroApoioAnexoSalvoResposta, setCentroApoioAnexoSalvoResposta] = useState<CentroApoioAnexo[] | null>(null);
  const { data: dataAnexoResposta, isLoading: isLoadingAnexoResposta } = useGetCentroApoioAnexosRespostaQuery({ idCentroApoioAnexo: dados.id ?? '' }, { skip: !dados.id });
  useEffect(() => {
    if (dataAnexoResposta) {
      setCentroApoioAnexoSalvoResposta(dataAnexoResposta);
    }
  }, [dataAnexoResposta]);

  async function handleConsultar() {
    if (!login || !senha) {
      enqueueSnackbar('Informe o login e a senha.', { variant: 'warning' });
      return;
    }

    const result: any = await consultarCentroApoio({ login, senha });

    if (result?.error) {
      enqueueSnackbar('Login ou senha inválidos.', { variant: 'error' });
      return;
    }

    setDados(result.data);
    setCentroApoioAnexoSalvo(null);
  }

  return (
    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
      <Paper
        sx={{
          width: '100%',
          p: 3,
          mx: 'auto',
          maxWidth: {
            xs: '100%', // celular
            sm: '600px', // tablets
            md: '800px', // telas médias
            lg: '1000px', // telas grandes
            xl: '1200px' // monitores muito grandes
          }
        }}
      >
        {!dados.id ? (
          <>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Consulte sua Solicitação ao Centro Apoio
            </Typography>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField label="Login" fullWidth size="small" value={login} onChange={e => setLogin(e.target.value)} />
              </Grid>

              <Grid item xs={12}>
                <TextField label="Senha" fullWidth type="password" size="small" value={senha} onChange={e => setSenha(e.target.value)} />
              </Grid>

              <Grid item xs={12}>
                <Button variant="contained" color="secondary" onClick={handleConsultar}>
                  Consultar
                </Button>
              </Grid>
            </Grid>
          </>
        ) : (
          <>
            {!edicao && (
              <>
                <CentroApoioPainelDadoAtual dados={dados} centroApoioAnexoSalvo={centroApoioAnexoSalvo} isLoadingAnexo={isLoadingAnexo} />

                <Button
                  variant="contained"
                  sx={{ mt: 3 }}
                  onClick={() => {
                    setDados(IScentroApoioList);
                    setLogin('');
                    setSenha('');
                  }}
                >
                  Nova consulta
                </Button>

                <Button variant="outlined" sx={{ mt: 3, ml: 2 }} onClick={() => setEdicao(true)}>
                  Alterar meus dados
                </Button>

                <Button variant="outlined" sx={{ mt: 3, ml: 2 }} onClick={() => navigate(configSiteUrls.SITE_CENTRO_APOIO_PUBLIC_MENU)}>
                  Voltar
                </Button>
              </>
            )}
          </>
        )}
        {edicao && (
          <>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Altere seus dados do Centro de Apoio
            </Typography>
            <CentroApoioPainelAlteraDado edicao={edicao} setEdicao={setEdicao} centroApoio={dados} SetCentroApoio={setDados as React.Dispatch<React.SetStateAction<CentroApoio>>} />
          </>
        )}
      </Paper>
    </Box>
  );
};
